import request from '@/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/blade-system/tenant/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getSelect = (params) => {
  return request({
    url: '/blade-system/tenant/select',
    method: 'get',
    params: {
      params,
    },
  });
};
export const getDetail = id => {
  return request({
    url: '/blade-system/tenant/detail',
    method: 'get',
    params: {
      id,
    },
  });
};
export const getTenantQrCode = () => {
  return request({
    url: '/blade-system/tenant/getTenantQrCode',
    method: 'get',
    params: {
    },
  });
};

export const getTenant = () => {
  return request({
    url: '/blade-system/tenant/getTenant',
    method: 'get',
    params: {
    },
  });
};
export const remove = ids => {
  return request({
    url: '/blade-system/tenant/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = row => {
  return request({
    url: '/blade-system/tenant/submit',
    method: 'post',
    data: row,
  });
};

export const update = row => {
  return request({
    url: '/blade-system/tenant/submit',
    method: 'post',
    data: row,
  });
};

export const setting = (ids, form) => {
  return request({
    url: '/blade-system/tenant/setting',
    method: 'post',
    params: {
      ...form,
      ids,
    },
  });
};

export const datasource = (tenantId, datasourceId) => {
  return request({
    url: '/blade-system/tenant/datasource',
    method: 'post',
    params: {
      tenantId,
      datasourceId,
    },
  });
};

export const info = domain => {
  return request({
    url: '/blade-system/tenant/info',
    method: 'get',
    params: {
      domain,
    },
  });
};

export const packageInfo = tenantId => {
  return request({
    url: '/blade-system/tenant/package-detail',
    method: 'get',
    params: {
      tenantId,
    },
  });
};

export const packageSetting = (tenantId, packageId) => {
  return request({
    url: '/blade-system/tenant/package-setting',
    method: 'post',
    params: {
      tenantId,
      packageId,
    },
  });
};

export const syncBiz = tenantIds => {
  return request({
    url: '/blade-system/tenant/sync-biz',
    method: 'post',
    params: {
      tenantIds,
    },
  });
};
